import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react'
import { Button } from 'react-bootstrap';

import Table from '../../../../../facturotopia/table/Table';


class NominaPercepcionesList extends Component {

  handleEdit = (item) => {
    this.handleOnDelete(item);
    this.props.onEdit(item);
  }

  handleOnDelete = (item) => {
    const newData = this.props.data.filter((value) => {
      return value.id !== item.id;
    });

    this.props.onChange(newData);
  }

  render() {
    const { data = [] } = this.props;

    return (
      <>
        <Table
          columns={ columns(this.handleEdit, this.handleOnDelete) }
          rowKey={ 'id' }
          data={ data }
        >
        </Table>
      </>
    )
  }
}


const columns = (handleEdit, handleOnDelete) => [
  {
    align: 'center',
    key: '__',
    title: '',
    dataIndex: '__',
    render: (item) => {
      return (
        <>
          <Button
            variant="secondary"
            size="sm"
            onClick={ handleEdit.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['far', 'edit'] } />
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={ handleOnDelete.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['fas', 'trash'] } />
          </Button>
        </>
      );
    }
  },
  {
    key: 'TipoPercepcion',
    title: 'Tipo',
    dataIndex: 'TipoPercepcion',
  },
  {
    key: 'Clave',
    title: 'Clave',
    dataIndex: 'Clave',
  },
  {
    key: 'Concepto',
    title: 'Concepto',
    dataIndex: 'Concepto',
  },
  {
    align: 'right',
    key: 'ImporteGravado',
    title: 'Importe Gravado',
    dataIndex: 'ImporteGravado',
  },
  {
    align: 'right',
    key: 'ImporteExento',
    title: 'Importe Exento',
    dataIndex: 'ImporteExento',
  }
];

export default NominaPercepcionesList;